import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import LocalizedLink from '../components/LocalizedLink'

const StyledLinkedPages = styled.div`
  h1 {
    font-size: 24px;
    padding-bottom: 5px;
    color: ${props => props.theme.colors.greyDark};
  }

  ul {
    margin-left: 0;
  }

  ul li {
    position: relative;
    width: 100%;
    height: 51px;
  }
  ul li:not(:last-of-type) {
    border-bottom: solid 1px ${props => props.theme.colors.primary};
  }
  ul li a {
    display: block;
    position: relative;
    font-size: 16px;
    color: ${props => props.theme.colors.textDark};
    line-height: 51px;
    font-weight: 700;
    letter-spacing: 0.8px;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  ul li a::before {
    display: inline-block;
    position: relative;
    color: ${props => props.theme.colors.primary};
    font-family: 'Font Awesome 5 Free';
    content: '\\f101';
    font-weight: 900;
    margin-right: 4px;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  ul li:hover a,
  ul li:hover a::before {
    color: ${props => props.theme.colors.primary};
  }
`

const LinkedPages = ({ input }) => (
  <StyledLinkedPages>
    <h1>{input.primary.pages_title}</h1>
    <ul>
      {input.items.map(item => (
        <li key={`linked-page-${item.linked_page.uid}`}>
          <LocalizedLink title={item.linked_page.document[0].data.title.text} to={`/a/${item.linked_page.uid}`}>{item.linked_page.document[0].data.menu_title.text}</LocalizedLink>
        </li>
      ))}
    </ul>
  </StyledLinkedPages>
)

export default LinkedPages

LinkedPages.propTypes = {
  input: PropTypes.object.isRequired,
}
